
import * as handlebars_family from "../handlebars_family.ts";

const TPL = handlebars_family.addTemplate("modal/toast_simple",{"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<icon style=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"iconStyle") : depth0), depth0))
    + "\">"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"svg") : depth0), depth0)) != null ? stack1 : "")
    + "</icon>";
},"3":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<icon>"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"icon") : depth0), depth0))
    + "</icon>";
},"5":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<emoji>"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"emoji") : depth0), depth0))
    + "</emoji>";
},"7":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <a class=\"color-branded\">"
    + container.escapeExpression(lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"title") : depth0),{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":373},"end":{"line":1,"column":387}}}))
    + "</a> ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"V4 toast animated fadeInUp flexrow\" style=\"background-color:#303742;color:#fff;\"> "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"svg") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":94},"end":{"line":1,"column":160}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"icon") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":161},"end":{"line":1,"column":203}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"emoji") : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":204},"end":{"line":1,"column":250}}})) != null ? stack1 : "")
    + " <flexauto style=\"height: fit-content;overflow: hidden;\"> "
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"text") : depth0), depth0))
    + " </flexauto> "
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"button") : depth0),{"name":"each","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":331},"end":{"line":1,"column":401}}})) != null ? stack1 : "")
    + " <icon>"
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"ic_close",{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":408},"end":{"line":1,"column":430}}}))
    + "</icon></div>";
},"useData":true});
export default TPL;